import { Column } from "react-table";
import {
  GetComplianceInvestigationEffectsFetchUrl,
  IComplianceInvestigationEffect,
} from "../../api/ComplianceInvestigation/IComplianceInvestigationEffect";
import { Grid } from "../Grid";
import { ComplianceInvestigationEffectsGridProps } from "./ComplianceInvestigationEffectsGridProps";

const ComplianceInvestigationEffectsGrid = ({
  complianceInvestigationId,
  licenceProfile,
}: ComplianceInvestigationEffectsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetComplianceInvestigationEffectsFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(complianceInvestigationId);

  const tableColumnsBig: Column<
    Record<string, IComplianceInvestigationEffect>
  >[] = [
    {
      Header: "Effect",
      accessor: "effect",
      Filter: false,
    },
    {
      Header: "Likelihood",
      accessor: "likelihood",
      Filter: false,
    },
    {
      Header: "Severity",
      accessor: "severity",
      Filter: false,
    },
    {
      Header: "Risk Score",
      accessor: "riskscore",
      Filter: false,
    },
    {
      Header: "Description",
      accessor: "description",
      Filter: false,
      filter: "includes",
    },
  ];

  const tableColumnsSmall: Column<
    Record<string, IComplianceInvestigationEffect>
  >[] = [
    {
      Header: "Effect",
      accessor: "effect",
      Filter: false,
    },
    {
      Header: "Likelihood",
      accessor: "likelihood",
      Filter: false,
    },
    {
      Header: "Severity",
      accessor: "severity",
      Filter: false,
    },
    {
      Header: "Risk Score",
      accessor: "riskscore",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { ComplianceInvestigationEffectsGrid };
